// Less restrictive https://github.com/sinsunsan/arsultima/issues/486
export const WEB_URL_PATTERN = '^(https?:\\/\\/)?(www\\.)?[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}.*$';

// https or http required but block old data
// export const WEB_URL_PATTERN = '^(?:https?|ftp)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]*[-A-Za-z0-9+&@#/%=~_|]$';
export const EMAIL_PATTERN = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
